module.exports = __webpack_public_path__ + "img/solicitudes.591a03e1.svg";